<template>
  <div class="w-100">
    <proa-heading>{{ $t('pages.member.heading') }}</proa-heading>
    <proa-heading sub class="mt-4 pt-3 mb-3 pb-1">{{ $t('pages.member.pickupMember') }}</proa-heading>
    <draggable
      class="d-flex favorite-users-wrapper"
      group="favoriteUsers"
      handle=".move-handler"
      v-model="favoriteUsers"
      v-bind="dragOptions"
      @end="onDragEndFavoriteUsers"
      :move="onDragMoveFavoriteUsers"
    >
      <user-card
        v-for="favoriteUser in displayFavoriteUsers"
        :key="favoriteUser.id"
        :user="favoriteUser"
        :handleMove="true"
        class="user-card"
        @click.native="onClickUser(favoriteUser.id)"
      />
      <draggable
        class="favorite-user-drop-area"
        group="otherUsers"
        v-model="dropFavoriteUser"
        @end="onDragEndFavoriteUserDropZone"
      >
        <div class="favorite-user-drop-zone">追加</div>
      </draggable>
    </draggable>
    <proa-heading sub class="mt-4 pt-3 mb-3 pb-1">{{ $t('pages.member.otherMember') }}</proa-heading>
    <draggable
      class="other-user-drop-zone"
      group="favoriteUsers"
      v-model="dropOtherUser"
    />
    <draggable
      :class="['d-flex flex-wrap other-users-wrpper', { 'droped': droped }]"
      group="otherUsers"
      handle=".move-handler"
      v-model="otherUsers"
      v-bind="dragOptions"
      @end="onDragEndFavoriteUserDropZone"
      :sort="false"
    >
      <user-card
        v-for="otherUser in displayOtherUsers"
        :key="otherUser.id"
        :user="otherUser"
        :handleMove="true"
        class="user-card"
        @click.native="onClickUser(otherUser.id)"
      />
    </draggable>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import User from '@/store/models/User'
import UserCard from '@/components/molecules/UserCard'

export default {
  name: 'IndexMember',
  components: {
    UserCard,
    draggable
  },
  computed: {
    dragOptions: function(){
      return {
        animation: 200
      }
    },
    displayFavoriteUsers: function() {
      return this.favoriteUsers.map(favoriteUser => {
        return User.find(favoriteUser.id)
      }).filter(favoriteUser => favoriteUser != null)
    },
    displayOtherUsers: function() {
      return this.otherUsers.map(otherUser => {
        return User.find(otherUser.id)
      }).filter(otherUser => otherUser != null)
    },
    ...mapGetters({
      signedInUser: 'auth/signedInUser'
    })
  },
  data() {
    return {
      droped: false,
      favoriteUsers: [],
      otherUsers: [],
      dropFavoriteUser: [],
      dropOtherUser: []
    }
  },
  methods: {
    onDragEndFavoriteUsers: function(e) {
      if (e.from !== e.to) {
        this.otherUsers.push(this.dropOtherUser[0])
        this.dropOtherUser = []
        this.updateFavoriteUsers()
      } else if (e.oldIndex !== e.newIndex) {
        this.updateFavoriteUsers()
      }
      this.droped = false
    },
    onDragMoveFavoriteUsers: function(e) {
      this.droped = e.from !== e.to
    },
    onDragEndFavoriteUserDropZone: function() {
      if (!this.dropFavoriteUser[0]) return
      this.favoriteUsers.push(this.dropFavoriteUser[0])
      this.dropFavoriteUser = []
      this.updateFavoriteUsers()
    },
    onClickUser: function(id) {
      this.$router.push({ name: 'showMember', params: { id: id } })
    },
    setUsers: function() {
      this.setFavoriteUsers()
      this.setOtherUsers()
    },
    setFavoriteUsers: function() {
      this.favoriteUsers = this.signedInUser.favoriteUsers.slice().sort((first, second) => {
        return first.listSequenceNo - second.listSequenceNo
      }).map(favoriteUser => {
        return User.find(favoriteUser.userId)
      })
    },
    setOtherUsers: function() {
      const favoriteUserIds = this.signedInUser.favoriteUsers.map(favoriteUser => favoriteUser.userId)
      this.otherUsers = User.query().where((user) => {
        return !favoriteUserIds.includes(user.id) && this.signedInUser.id != user.id
      }).get()
    },
    updateFavoriteUsers: function() {

      // 中間テーブルのID配列
      const userFavoriteUsersAttributes = this.favoriteUsers.map((user, listSequenceNo) => {
        let newUserFavoriteUser
        const currentUserFavoriteUser = this.signedInUser.favoriteUsers.filter(favoriteUser => favoriteUser.userId == user.id)
        if (currentUserFavoriteUser.length) {
          newUserFavoriteUser = {
            id: currentUserFavoriteUser[0].id,
            userId: user.id,
            listSequenceNo: listSequenceNo
          }
        } else {
          newUserFavoriteUser = {
            userId: user.id,
            listSequenceNo: listSequenceNo
          }
        }
        return newUserFavoriteUser
      })

      this.apiUpdateFavoriteUsers({
        userFavoriteUsersAttributes: userFavoriteUsersAttributes
      })
    },
    ...mapActions({
      apiGetUsers: 'entities/users/index',
      apiUpdateFavoriteUsers: 'userOrganization/update'
    })
  },
  async created () {
    if (User.all().length > 1) this.setUsers()

    await this.apiGetUsers()
    this.setUsers()
  },
}
</script>
<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.user-card {
  margin: 2px 8px 8px 2px;
  cursor: pointer;
  width: 101px;

  @include mq(md) {
    width: 120px;
  }
}

.favorite-users-wrapper {
  overflow-x: auto;
  min-height: 150px;
  margin: -1rem 0 -1.5rem 0;
  padding: 1rem 0 1.5rem 0;

  @include mq(md) {
    flex-wrap: wrap;
    margin: 0;
    padding: 0.6rem 0 0;
  }

  .user-card {
    flex-shrink: 0;
    width: 120px;
  }

}

.favorite-user-drop-zone {
  width: 120px;
  height: 150px;
  padding: 10px;
  border-radius: 4px;
  border: 2px dashed $dark-border-color;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $dark-border-color;
  font-size: 12px;
  font-weight: 600;

  @include mq(md) {
    position: absolute;
  }
}

.other-user-drop-zone {
  position: absolute;
  width: 80%;
  height: 150px;
  background: transparent;
  pointer-events: none;
}

.droped {
  .user-card:first-child {
    margin-left: 132px;
  }
}

.favorite-user-drop-area {
  width: 120px;
  height: 150px;
}
</style>
